import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: 'iconByName', pure: true})
export class IconByNamePipe implements PipeTransform {
  private static ICONS_PATH = 'assets/media/vescent/icons';

  transform(value: string) {
    return `${IconByNamePipe.ICONS_PATH}/${value}.svg`;
  }
}